import React, { useContext, useCallback } from 'react'
import { ReportingContext } from '../../../../wrappers/ReportingContext'

const ReportEditorModal = () => {
    const { modal, setModal } = useContext(ReportingContext)
    const { display: showModal, title, message, confirmText, confirmAction, cancelAction } = modal

    const onConfirm = useCallback(() => {
        confirmAction()
        setModal({ display: false })
    }, [confirmAction, setModal])

    const onCancel = useCallback(() => {
        cancelAction()
        setModal({ display: false })
    }, [cancelAction, setModal])

    return (
        <div className={`modal ${showModal ? 'is-active' : ''}`}>
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="box">
                    <h1 className="subtitle">{title}</h1>
                    <div className="content">
                        <p>{message}</p>
                    </div>
                    <div className="content">
                        <div className="buttons">
                            <button className="button is-primary" onClick={() => onConfirm()}>
                                {confirmText}
                            </button>
                            <button className="button is-danger" onClick={() => onCancel()}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportEditorModal
